@if (visible()) {
  <button [class]="class()" (click)="back()">{{ 'misc.back_btn' | translate }}</button>
}
